module.exports = __webpack_public_path__ + "img/header.b8f196f7.svg";